import React from 'react';
import { CSSProperties } from 'styled-components';

const IcArrowRightSlim = ({ $width, $height, $color, $position }: { $width?: string; $height?: string; $color?: string; $position?: CSSProperties['position'] }) => {
    return (
        <svg style={{ position: $position }} width={$width || '16'} height={$height || '20'} viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.41968 15.5303C6.71258 15.8232 7.18745 15.8232 7.48034 15.5303L12.4803 10.5303C12.7732 10.2374 12.7732 9.76256 12.4803 9.46967L7.48034 4.46967C7.18745 4.17678 6.71258 4.17678 6.41968 4.46967C6.12679 4.76256 6.12679 5.23744 6.41968 5.53033L10.8894 10L6.41968 14.4697C6.12679 14.7626 6.12679 15.2374 6.41968 15.5303Z'
                fill={$color || '#989BA2'}
            />
        </svg>
    );
};

export default IcArrowRightSlim;
